// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'download';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 14.061V.561M6.188 11.248 9 14.062l2.813-2.813M.563 17.436h16.875'
  />
);

export const viewBox = '0 0 18 18';
